import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HrtApiService } from '../hrt-api/hrt-api.service';
import { MachineDetails, MachineOverviewModel, MachinesDTOResponse } from '@shared/state';

@Injectable({
  providedIn: 'root',
})
export class MachinesApiService {
  readonly machinesUrl = 'machines';
  readonly api = inject(HrtApiService);

  fetchMachines(): Observable<MachinesDTOResponse> {
    return this.api.getForOrganization<MachinesDTOResponse>(this.machinesUrl);
  }

  fetchMachineDetails(machineId: number): Observable<MachineDetails> {
    return this.api.get<MachineDetails>(`${this.machinesUrl}/${machineId}`);
  }

  public updateMachine(id: number, machine: MachineOverviewModel) {
    return this.api.patch<void>(`machines/${id}`, machine);
  }
}
